import { render } from "./edit.vue?vue&type=template&id=684cf590&scoped=true"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"

import "./edit.vue?vue&type=style&index=0&id=684cf590&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-684cf590"

export default script